import type { IFilterPanelBaseFilterDeps, IFilterPanelBaseFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { AppsAdsSellersFilterDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsAdSellersFilterItem } from "app/pages/sales-intelligence/store/find-apps/types";

export default class FindAppsAdsSellersFilter
    extends FilterPanelBaseFilter<IAppsAdSellersFilterItem[], AppsAdsSellersFilterDescriptionDto>
    implements IFilterPanelBaseFilterModel<IAppsAdSellersFilterItem[], AppsAdsSellersFilterDescriptionDto>
{
    constructor(deps: IFilterPanelBaseFilterDeps<IAppsAdSellersFilterItem[], AppsAdsSellersFilterDescriptionDto>) {
        super(deps);
    }

    isFilterDirty(currentValue: IAppsAdSellersFilterItem[] | undefined): boolean {
        return Boolean(currentValue && currentValue.length > 0);
    }
}
